import React from 'react';

import { AlmaLink } from '../alma-link';

export function Links(category) {
  return category?.nestedMenuCtas
    ? category?.nestedMenuCtas?.map(footerItem => {
      return (
        <li key={footerItem?._key}>
          <AlmaLink cta={footerItem} />
        </li>
      );
    })
    : null;
};
